import React from 'react'
import _ from 'lodash'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import { Clipboard, TouchableOpacity } from 'react-native'

import * as util from 'x/utils/util'
import { getStoreSelected, getSelectedProduct } from 'x/redux/selectors'
import * as NavActions from 'x/utils/navigation'
import * as api from 'x/utils/api'
import p from 'x/config/platform-specific'

import {
  IProductDetailItemMap,
  IVariantMkpInfo,
  ISelectedStoreMap,
  IProductDetailVariant,
  IComputedVariantMkpInfo,
  IAnyObject,
  INavHeaderButtonProps,
  IProductBundleMapperNavParams,
  IXScreenProps,
  ISearchProductItem,
  IBundleProductMapping,
  IBundleProductVariant,
  IProductBundleQtyMapping,
  IProductDetailBundledVariant,
} from 'x/index'

import XText from 'xui/components/XText'
import XCard from 'xui/components/XCard'
import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import MkpLogo from 'xui/components/MkpLogo'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCustomHeader from 'xui/components/XCustomHeader'
import XImage from 'xui/components/XImage'
import Box from 'xui/components/Box'
import XButton from 'xui/components/XButton'
import XIcon from 'xui/components/XIcon'
import XSellyLogo from 'xui/components/XSellyLogo'
import XInput from 'xui/components/XInput'
import XNumericInput from 'xui/components/XNumericInput'
import HelpButton from 'xui/components/HelpButton'

interface IProps extends IXScreenProps<IProductBundleMapperNavParams> {
  selectedStore: ISelectedStoreMap
}

interface IState {
  isInitialized?: boolean
  // variants: IProductDetailVariant[]

  // selectedBundledProducts: ISearchProductItem[] //  เก็บสินค้าที่เลือกเพิ่มในเซต
  selectedBundleProductVariant: IBundleProductVariant //  เก็บข้อมูลของ variant

  editingBundledPpIds: number[] //  เก็บสินค้าที่เลือกเพิ่มในเซต
  editingBundleMappings: {
    [ppId: number]: IProductBundleQtyMapping
  } //  เก็บการแมพสินค้าที่เลือกเพิ่มในเซต

  //  เอาไว้แสดงเฉพาะตัวที่สนใจ (pp_id ส่งมาจาก nav param)
  // visibleVariantIndex?: number
  type: 'bundle' | 'assembly'
  mode: 'detail' | 'edit' | 'create' | 'convert' | 'create-edit'
}

class ProductBundleMapper extends React.Component<IProps, IState> {
  static displayName = 'ProductBundleMapper'

  constructor(props) {
    super(props)
    this.state = {
      isInitialized: false,
      type: 'bundle',
      mode: 'detail',

      // selectedBundledProducts: [],
      editingBundledPpIds: [],
      editingBundleMappings: {},
    }
  }

  async componentDidMount() {
    await this._initialize()
    await util.delay(100)
    await this._fetchProductBundleDetail()
    await util.delay(100)
    await util.setStatePromise(this, { isInitialized: true })
    await this._initialNav()
  }

  _initialize = async () => {
    const mode = util.getNavParam(this.props, 'mode')
    const type = util.getNavParam(this.props, 'type')

    const initialBundleProductVariant = util.getNavParam(this.props, 'initialBundleProductVariant')
    if (initialBundleProductVariant && _.isArray(initialBundleProductVariant.bundle_product_mappings)) {
      const editingBundledPpIds = initialBundleProductVariant.bundle_product_mappings.map((mapping) => mapping.pp_id) || []
      const editingBundleMappings: IAnyObject = {}
      initialBundleProductVariant.bundle_product_mappings.forEach((mapping) => {
        editingBundleMappings[mapping.pp_id] = mapping
      })

      await util.setStatePromise(this, {
        editingBundledPpIds,
        editingBundleMappings,
        selectedBundleProductVariant: initialBundleProductVariant,
      })
    }

    await util.setStatePromise(this, { mode, type })
  }

  _initialNav = async () => {
    const { type, mode } = this.state

    if (mode === 'create') {
      this._navToSearchProductVariantListView()
    }
  }

  _fetchProductBundleDetail = async () => {
    const { selectedStore } = this.props
    const store_id = util.getNavParam(this.props, 'store_id')
    const product_bundle_id = util.getNavParam(this.props, 'product_bundle_id')
    if (!product_bundle_id) {
      return
    }

    try {
      const res = await api.fetchProductBundleDetail({ store_id, product_bundle_id })
      await this._loadProductBundleDetail(res)
    } catch (error) {
      p.op.showToast('ไม่พบข้อมูลสินค้าเซต', 'danger')
    }
  }

  _loadProductBundleDetail = async (pdbv: IProductDetailBundledVariant) => {
    if (pdbv && 'pp_id' in pdbv) {
      const editingBundledPpIds = pdbv.bundle_product_mappings.map((mapping) => mapping.pp_id) || []
      const editingBundleMappings: IAnyObject = {}
      pdbv.bundle_product_mappings.forEach((mapping) => {
        editingBundleMappings[mapping.pp_id] = mapping
      })

      await util.setStatePromise(this, {
        editingBundledPpIds,
        editingBundleMappings,
        selectedBundleProductVariant: pdbv,
      })
    }
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _getHeaderTitle = () => {
    const { mode, type } = this.state
    let headerTitle

    if (type === 'bundle') {
      headerTitle = 'รายละเอียดสินค้าเซต'

      if (mode === 'edit') {
        headerTitle = 'แก้ไขสินค้าเซต'
      }

      if (mode === 'create' || mode === 'create-edit') {
        headerTitle = 'สร้างสินค้าเซต'
      }

      if (mode === 'convert') {
        headerTitle = 'แปลงเป็นสินค้าเซต'
      }
    }

    if (type === 'assembly') {
      headerTitle = 'รายละเอียดสินค้าประกอบ'

      if (mode === 'edit') {
        headerTitle = 'แก้ไขสินค้าประกอบ'
      }

      if (mode === 'create' || mode === 'create-edit') {
        headerTitle = 'สร้างสินค้าประกอบ'
      }

      if (mode === 'convert') {
        headerTitle = 'แปลงเป็นสินค้าประกอบ'
      }
    }

    return headerTitle
  }

  _onSave = async () => {
    const { editingBundledPpIds, editingBundleMappings, mode, type } = this.state
    const bundleMappings: IProductBundleQtyMapping[] = editingBundledPpIds.map((ppId) => {
      return {
        ...editingBundleMappings[ppId],
      }
    })
    console.log('bundleMappings => ', bundleMappings)

    if (type === 'bundle' && mode === 'edit') {
      // Handle edit mode for bundle
      await this._editBundleProductMappings(bundleMappings)
      return
    }

    if (type === 'assembly' && mode === 'edit') {
      // Handle edit mode for assembly
      // await this._editBundleProductMappings(bundleMappings)
      return
    }

    await this._doOnSubmitCallback(bundleMappings)
  }

  _doOnSubmitCallback = async (bundleMappings: IProductBundleQtyMapping[]) => {
    const onSubmitMappings = util.getNavParam(this.props, 'onSubmitMappings')

    if (_.isFunction(onSubmitMappings)) {
      try {
        await onSubmitMappings(bundleMappings)
        p.op.showToast('บันทึกสำเร็จ', 'success')
        this._goBack()
      } catch (error) {
        p.op.showToast(JSON.stringify(error), 'danger')
      }
    }
  }

  _editBundleProductMappings = async (bundleMappings: IProductBundleQtyMapping[]) => {
    const { selectedBundleProductVariant } = this.state

    try {
      const res = await api.editProductBundle({
        store_id: util.getNavParam(this.props, 'store_id'),
        product_product_id: selectedBundleProductVariant.pp_id,
        product_bundle_id: selectedBundleProductVariant.product_bundle_id,
        bundle_product_mappings: bundleMappings,
      })

      await this._loadProductBundleDetail(res)
    } catch (error) {
      p.op.showToast(JSON.stringify(error), 'danger')
    }
  }

  _getHeaderLeftProps = (): INavHeaderButtonProps => {
    const { mode } = this.state
    let headerLeftProps: INavHeaderButtonProps = { backIcon: true, onPressItem: this._goBack }

    if (mode === 'detail') {
      return headerLeftProps
    }

    headerLeftProps = {
      label: 'บันทึก',
      onPressItem: this._onSave,
    }

    return headerLeftProps
  }

  _getHeaderRightProps = (): INavHeaderButtonProps => {
    const { mode } = this.state

    if (mode === 'detail') {
      return null
    }

    return {
      label: 'ยกเลิก',
      onPressItem: this._goBack,
    }
  }

  _renderCustomHeader = () => {
    const { mode } = this.state

    return (
      <XCustomHeader
        title={this._getHeaderTitle()}
        headerLeftProps={this._getHeaderLeftProps()}
        headerRightProps={this._getHeaderRightProps()}
      />
    )
  }

  _renderSearchBar = () => {
    const { selectedStore } = this.props

    return (
      <HStack w='full' alignItems='center' justifyContent='space-between' px='4' py='2'>
        <XInput placeholder='ค้าหาสินค้าในเซต' w='full' />
      </HStack>
    )
  }

  _convertProductListItemToProductBundleQtyMapping = (item: ISearchProductItem): IProductBundleQtyMapping => {
    return {
      pp_id: item.v[0].i,
      pt_name: item.n,
      pp_name: item.v[0].n || '',
      sku: item.v[0].sku || '',
      upc: item.v[0].upc || '',
      tiny_img_url: item.v[0].img_url || item.t[0] || '',
      qty: 1, // default to 1, can be changed later
      unit_price_weight: '0',
      // unit_cost_weight: '0',
    }
  }

  _onAddProductItemToBundlePressed = (productItem: ISearchProductItem) => {
    // const { selectedBundledProducts } = this.state

    // const newSelectedProducts = [...selectedBundledProducts, productItem]
    // this.setState({ selectedBundledProducts: newSelectedProducts })

    const { editingBundledPpIds: oldPpIds, editingBundleMappings: oldMappings } = this.state
    const ppId = productItem.v[0].i
    const editingBundledPpIds = oldPpIds.includes(ppId) ? oldPpIds : [...oldPpIds, ppId]
    let editingBundleMappings: {
      [ppId: number]: IProductBundleQtyMapping
    }

    if (oldMappings[ppId]) {
      //  ถ้ามี ppId นี้อยู่แล้ว ให้ไม่ทำอะไร
      editingBundleMappings = {
        ...oldMappings,
        [ppId]: {
          ...oldMappings[ppId], //  คัดลอกข้อมูลจาก oldMappings[ppId]
          qty: oldMappings[ppId].qty + 1, //  เพิ่ม qty ขึ้น 1
        },
      }
    } else {
      editingBundleMappings = {
        ...oldMappings,
        [ppId]: this._convertProductListItemToProductBundleQtyMapping(productItem), //  แปลง item เป็น IProductBundleQtyMapping
      }
    }

    this.setState({ editingBundledPpIds, editingBundleMappings }, () => {
      const listItemsText = editingBundledPpIds
        .map((ppId) => {
          const item = editingBundleMappings[ppId]
          const vName = item.pp_name && item.pp_name.length > 0 ? item.pp_name : null
          const productName = `${item.pp_name}${vName ? ` (${vName})` : ''}`
          return `${item.qty}x ${productName}`
        })
        .join('\n')

      const summaryText = `เพิ่มสินค้า ${productItem.n} ในเซตสำเร็จ\n\n${listItemsText}`
      p.op.showToast(summaryText, 'success')
    })
  }

  _navToSearchProductVariantListView = () => {
    const { navigation, selectedStore } = this.props
    const store_id = util.getNavParam(this.props, 'store_id')
    const renderNavReference = util.getNavParam(this.props, 'renderNavReference')

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id,

        defaultFilter: {
          isBundleProduct: false,
          isAssemblyProduct: false,
          isStandardProduct: true,
          isProductVariantTypeFilterHidden: true, //  ซ่อนตัวเลือกประเภทสินค้า
        },

        renderNavReference,
        onProductItemPressed: this._onAddProductItemToBundlePressed,
        productItemButtonText: 'เพิ่มสินค้าในเซต',
        isNavToProductDetailDisabled: true,
      })
    )
  }

  _renderAddProductToBundleButton = () => {
    const { mode } = this.state
    if (mode === 'detail') {
      return null
    }

    return (
      <HStack w='full' alignItems='center' justifyContent='center' px='4' py='2'>
        <XButton w='full' onPress={this._navToSearchProductVariantListView}>
          เพิ่มสินค้าในเซต
        </XButton>
      </HStack>
    )
  }

  _removeSelectedProduct = (ppId: number) => {
    // const { selectedBundledProducts } = this.state

    // const newSelectedProducts = selectedBundledProducts.filter((_, i) => i !== index)
    // this.setState({ selectedBundledProducts: newSelectedProducts })
    const { editingBundledPpIds: oldPpIds, editingBundleMappings: oldMappings } = this.state

    const editingBundledPpIds = oldPpIds.filter((id) => id !== ppId)
    const editingBundleMappings = _.omit(oldMappings, ppId)

    this.setState({ editingBundledPpIds, editingBundleMappings })
  }

  _renderSelectedProductPpId = (ppId: number, index: number) => {
    const { editingBundleMappings } = this.state
    const productItem = editingBundleMappings[ppId]
    if (_.isNil(productItem) || _.isEmpty(productItem)) {
      return null
    }

    return this._renderBundleProductMappingItem(productItem, index)
  }

  _renderProductVariantBundleMappingQty = (pbm: IProductBundleQtyMapping) => {
    const { mode } = this.state
    if (mode === 'detail') {
      return (
        <VStack w='full' space='1'>
          <HStack w='full' alignItems='center' space='1'>
            <HStack w='220px' alignItems='center' space='1'>
              <XText variant='inactive'>ราคาขายสัดส่วนต่อหน่วย</XText>
            </HStack>

            <XText flex={1} textAlign='right'>
              {pbm.unit_price_weight}
            </XText>
          </HStack>

          {/* <HStack w='full' alignItems='center' space='1'>
            <HStack w='220px' alignItems='center' space='1'>
              <XText variant='inactive'>ต้นทุนสัดส่วนต่อหน่วย</XText>
            </HStack>

            <XText flex={1} textAlign='right'>
              {pbm.unit_cost_weight}
            </XText>
          </HStack> */}

          <HStack w='full' alignItems='center' space='1'>
            <HStack w='220px' alignItems='center' space='1'>
              <XText variant='inactive'>จำนวน (ต่อเซต)</XText>
            </HStack>

            <XText flex={1} bold textAlign='right'>
              {pbm.qty}
            </XText>
          </HStack>
        </VStack>
      )
    }

    return (
      <VStack w='full' space='1'>
        <HStack w='full' alignItems='center' space='1'>
          <HStack w='220px' alignItems='center' space='1'>
            <XText variant='inactive'>ราคาขายสัดส่วนต่อหน่วย</XText>

            <HelpButton title='น้ำหนักของราคา' message='น้ำหนักของราคาสินค้าในเซตนี้ จะถูกใช้ในการคำนวณราคาขายและต้นทุนของสินค้าเซต' />
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XInput
              w='150px'
              isMoney
              value={pbm.unit_price_weight}
              keyboardType='numeric'
              textAlign='right'
              onChangeText={(value) => {
                const { editingBundleMappings } = this.state
                const newMappings = {
                  ...editingBundleMappings,
                  [pbm.pp_id]: {
                    ...editingBundleMappings[pbm.pp_id],
                    unit_price_weight: value,
                  },
                }
                this.setState({ editingBundleMappings: newMappings })
              }}
            />
          </HStack>
        </HStack>

        {/* <HStack w='full' alignItems='center' space='1'>
          <HStack w='220px' alignItems='center' space='1'>
            <XText variant='inactive'>ต้นทุนสัดส่วนต่อหน่วย</XText>

            <HelpButton title='น้ำหนักของต้นทุน' message='น้ำหนักของต้นทุนสินค้าที่ใช้ในการคำนวณต้นทุนของสินค้าเซต' />
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XInput
              w='150px'
              isMoney
              value={pbm.unit_cost_weight}
              keyboardType='numeric'
              textAlign='right'
              onChangeText={(value) => {
                const { editingBundleMappings } = this.state
                const newMappings = {
                  ...editingBundleMappings,
                  [pbm.pp_id]: {
                    ...editingBundleMappings[pbm.pp_id],
                    unit_cost_weight: value,
                  },
                }
                this.setState({ editingBundleMappings: newMappings })
              }}
            />
          </HStack>
        </HStack> */}

        <HStack w='full' alignItems='center' space='1'>
          <HStack w='220px' alignItems='center' space='1'>
            <XText variant='inactive'>จำนวน (ต่อเซต)</XText>
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XNumericInput
              w='150px'
              value={pbm.qty}
              keyboardType='numeric'
              onChangeValue={(value) => {
                const { editingBundleMappings } = this.state
                const newMappings = {
                  ...editingBundleMappings,
                  [pbm.pp_id]: {
                    ...editingBundleMappings[pbm.pp_id],
                    qty: value,
                  },
                }
                this.setState({ editingBundleMappings: newMappings })
              }}
              minValue={1}
            />
          </HStack>
        </HStack>
      </VStack>
    )
  }

  _renderBundleProductMappingItem = (pbm: IProductBundleQtyMapping, index: number) => {
    // const { selectedBundledProducts } = this.state
    const { mode } = this.state
    const { pp_id, pp_name, pt_name, tiny_img_url, sku, upc } = pbm

    return (
      <XCard w='full' key={`${index}_${pp_id}`}>
        <VStack w='full' p='2' minH='12' alignItems='center' space='1'>
          <HStack w='full' p='2' minH='12' space='1'>
            <HStack
              w='48px'
              h='48px'
              alignItems='center'
              justifyContent='center'
              borderWidth='1'
              borderColor='gray.200'
              borderRadius='lg'
              overflow='hidden'>
              <XImage w='48px' h='48px' source={{ uri: tiny_img_url }} />
            </HStack>

            <VStack flex={1} space='1'>
              <XText variant='inactive' numberOfLines={1}>
                {pt_name}
              </XText>
              <XText numberOfLines={1}>{pp_name}</XText>
              {sku && sku.length > 0 && (
                <XText variant='inactive' fontSize='xs'>
                  SKU: {sku}
                </XText>
              )}
              {upc && upc.length > 0 && (
                <XText variant='inactive' fontSize='xs'>
                  UPC: {upc}
                </XText>
              )}
            </VStack>

            {mode === 'detail' ? null : (
              <TouchableOpacity onPress={() => this._removeSelectedProduct(pp_id)}>
                <HStack w='24px' h='24px' alignItems='center' justifyContent='center'>
                  <XIcon name='trash' variant='danger' />
                </HStack>
              </TouchableOpacity>
            )}
          </HStack>
          {this._renderProductVariantBundleMappingQty(pbm)}
        </VStack>
      </XCard>
    )
  }

  _getSumOfEditingMappingQtyCount = () => {
    const { editingBundleMappings } = this.state
    return Object.values(editingBundleMappings).reduce((sum, mapping) => sum + mapping.qty, 0)
  }

  _renderContent = () => {
    // const { selectedBundledProducts } = this.state
    // return selectedBundledProducts.map(this._renderSelectedProductItem)

    const { editingBundledPpIds } = this.state

    return (
      <VStack w='full' p='2' space='1'>
        <XText variant='inactive'>
          เป็นสินค้าเซต ({editingBundledPpIds.length} สินค้า {this._getSumOfEditingMappingQtyCount()} ชิ้น)
        </XText>
        {editingBundledPpIds.length === 0 && (
          <HStack w='full' h='150px' alignItems='center' justifyContent='center' p='4'>
            <XText variant='inactive'>ยังไม่มีสินค้าในเซต กรุณาเพิ่มสินค้าก่อน</XText>
          </HStack>
        )}
        {editingBundledPpIds.map(this._renderSelectedProductPpId)}
      </VStack>
    )
  }

  render() {
    const { isInitialized } = this.state
    if (!isInitialized) {
      return null
    }

    const renderNavReference = util.getNavParam(this.props, 'renderNavReference')

    return (
      <XContainer>
        {_.isFunction(renderNavReference) ? renderNavReference() : null}
        {this._renderCustomHeader()}
        {/* {this._renderSearchBar()} */}

        <XContent style={{ backgroundColor: 'white' }}>{this._renderContent()}</XContent>

        {this._renderAddProductToBundleButton()}
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    // selectedProduct: getSelectedProduct(state),
    // mkpChannels: getMkpChannels(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(ProductBundleMapper)
